import { ErrorCode } from "@mebi/shared";

export const ErrorTranslations: Record<ErrorCode, string> = {
  [ErrorCode.NETWORK_ERROR]: "Lỗi kết nối mạng. Vui lòng kiểm tra lại.",
  [ErrorCode.UNAUTHORIZED]: "Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.",
  [ErrorCode.FORBIDDEN]: "Bạn không có quyền thực hiện thao tác này.",
  [ErrorCode.NOT_FOUND]: "Không tìm thấy dữ liệu yêu cầu.",
  [ErrorCode.VALIDATION_ERROR]: "Dữ liệu không hợp lệ.",
  [ErrorCode.INTERNAL_SERVER_ERROR]:
    "Lỗi máy chủ nội bộ. Vui lòng thử lại sau.",
  [ErrorCode.UNKNOWN_ERROR]: "Đã có lỗi xảy ra.",
  [ErrorCode.BAD_REQUEST]: "Yêu cầu không hợp lệ.",
  [ErrorCode.TIMEOUT]: "Yêu cầu quá thời gian chờ.",

  // Auth specific
  [ErrorCode.INVALID_CREDENTIALS]: "Thông tin đăng nhập không chính xác.",
  [ErrorCode.USER_NOT_FOUND]: "Không tìm thấy tài khoản.",
  [ErrorCode.EMAIL_ALREADY_EXISTS]: "Email đã được đăng ký.",
  [ErrorCode.ACCOUNT_LOCKED]: "Tài khoản đã bị khóa.",
  [ErrorCode.SESSION_EXPIRED]: "Phiên đăng nhập đã hết hạn.",
  [ErrorCode.INVALID_OTP]: "Mã OTP không đúng.",
  [ErrorCode.OTP_EXPIRED]: "Mã OTP đã hết hạn.",
};

export const translateErrorCode = (code: ErrorCode): string => {
  return ErrorTranslations[code] || ErrorTranslations[ErrorCode.UNKNOWN_ERROR];
};
